module.exports = __webpack_public_path__ + "img/tbn_slide_1.41b0d8d7.jpg";